import React from 'react';
import { Link } from 'react-router-dom';
import HubspotForm from 'react-hubspot-form'

const HeroSection = () => {
    return (
        <>
            <section className="hero__area pt-40 pb-50">
                <div className="hero__item">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-5 offset-lg-1 order-lg-last">
                                <div className="contact__home fix">
                                    <div className="contact__info">
                                        <h3>Get Your Office Quote Now!</h3>
                                    </div>
                                    <div className="contact__form home">
                                        <HubspotForm
                                            portalId="7848680"
                                            formId="cf71a51e-2ec0-4e62-a181-7c1ef898b72b"
                                            onSubmit={() => console.log('Submit!')}
                                            onReady={(form) => console.log('Form ready!')}
                                            loading={<div>Loading...</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="hero__content">
                                    <h1>Premisin Virtual Office - Virtual Office Space in Raipur</h1>
                                    <h2>Extend your business presence to any location through the convenience of a virtual office space in Raipur.</h2>
                                    <p>Acquire a Virtual Office and gain access to the advantages of a prestigious business address, all while avoiding the expenses associated with a physical office and high monthly rents.</p>
                                    <Link to="/raipur/virtual-office" className="z-btn z-btn-border">Enquire Now</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HeroSection;